import { createApp, h } from 'vue';
import PrimeVue from 'primevue/config';
import locale from '../utils/locale';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';

import twToast from '../components/basic/tw-toast.vue';
import twConfirm from '../components/basic/tw-confirm.vue';

const messageServer = function() {
    const pri = {
        showToast(severity, message, life) {
            const formElement = document.createElement('div')
            const bodyElement = document.getElementsByTagName('body')[0]
            bodyElement.appendChild(formElement)
            
            // 创建
            const app = createApp({
                render() {
                    return h(twToast, { severity, message, life });
                }
            })
            // 挂载
            app.use(PrimeVue, locale).use(ToastService).mount(formElement); 

            // 销毁
            setTimeout(() => {
                app?.unmount()
                bodyElement.removeChild(formElement)
            }, life);
        }
    }

    const pub = {
        // 提示信息
        success(message) {
            pri.showToast('success', message, 3000)
        },
        info(message) {
            pri.showToast('info', message, 3000)
        },
        warn(message) {
            pri.showToast('warn', message, 3000)
        },
        error(message) {
            pri.showToast('error', message, 3000)
        },

        // 确认信息
        confirm(message) {
            return new Promise((resolve, reject) => {
                let app
                const formElement = document.createElement('div')
                const bodyElement = document.getElementsByTagName('body')[0]
                bodyElement.appendChild(formElement)
                
                new Promise((subResolve, subReject) => {
                    // 创建
                    app = createApp({
                        render() {
                            return h(twConfirm, {
                                message,
                                resolve: subResolve,
                                reject: subReject
                            });
                        }
                    })
                    // 挂载
                    app.use(PrimeVue, locale).use(ConfirmationService).mount(formElement); 
                }).then(() => {
                    app?.unmount()
                    bodyElement.removeChild(formElement)

                    resolve()
                }).catch(err => {
                    app?.unmount()
                    bodyElement.removeChild(formElement)

                    reject(err)
                })
            })
        }
    }

    return pub
}

const service = new messageServer();

export default service;